import { compareAsc, isEqual } from "date-fns";
import React, { useEffect } from "react";
import { useDispatch,useSelector } from "react-redux";
import MdaeDateBox from "../common_widgets/date-box";
import MdaeSelectBox from "../common_widgets/select-box/component";
import {
  BULK_UPDATE_CONFIG_NAMES,
  externalAuditCaseFieldNames,
} from "./bulk-update-configuration";
import { actions } from "async-ops";
import { UPDATE_BULK_UPDATE_ROW } from "./reducers/bulk-update-popup-reducer";
import { GET_STATUS_LOOKUP_LIST } from "../../pages/external-audit/case-detail/case-data/services/get-audit-case-finding-status";
import { GET_OUTCOMES_LIST } from "../../pages/external-audit-setup/outcomes/services/get-outcomes-list";
import { SET_CASE_FORM_DATA } from "../../pages/external-audit/case-detail/case-data/reducers/case-data-reducer";
import { GET_TARGET_VALUE_LOOKUP } from "../../pages/external-audit/services/get-taregt-values";

interface IBulkUpdateValueField {
  currentBulkUpdateConfigurationName: string;
  currentBulkUpdateFieldName: string;
  currentBulkUpdateFieldValue: any;
  currentSequenceNumber: number;
}
const getTermDateMinValue = (effectiveDate) => {
  if (effectiveDate) {
    const date = new Date(effectiveDate);
    const isSmallerThanToday = compareAsc(date, new Date());
    if (isSmallerThanToday === -1) {
      return new Date(new Date().toDateString());
    } else return date;
  }
  return new Date(new Date().toDateString());
}; 
export const BulkUpdateValueField: React.FC<IBulkUpdateValueField> = (
  props
) => {
  const dispatch = useDispatch();
  const commonValueChangeHandler = (e) => {
    dispatch({
      type: UPDATE_BULK_UPDATE_ROW,
      data: {
        sequenceNumber: props.currentSequenceNumber,
        fieldValue: e.value,
      },
    });
  };

  const auditPropertiesData = useSelector(
  (state: any) => state.auditPropertiesReducer.auditPropertiesData,
  isEqual
); 
const denialReasonData = useSelector(
  (state: any) => state["caseDataReducer"].denialReasonData,
  isEqual
);
 const TargetRationaleList = useSelector(
      (state) => state["auditPropertiesReducer"].targetRationaleList
    );
  const processManagers = useSelector(
    (state) => state["auditPropertiesReducer"].processManagers,
    isEqual
  );
  useEffect(() => {
    if (
      props.currentBulkUpdateConfigurationName ===
      BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE
    ) {
      dispatch(
        actions.asyncOperationStart(GET_STATUS_LOOKUP_LIST, {
          entity: "EXTERNAL_AUDIT_CASE_STATUS",
        })
      );
      dispatch(actions.asyncOperationStart(GET_OUTCOMES_LIST, { isShowTermedOutcomes: false }));
      dispatch(
        actions.asyncOperationStart(GET_TARGET_VALUE_LOOKUP, {
          CodeType: "DENIAL_REASONS",
          EffectiveDate: new Date(),
          GroupId:auditPropertiesData.auditGroupId
        })
      );
    }
  }, [props.currentBulkUpdateConfigurationName]);
  return (
    <>
      <MdaeSelectBox
        mdaeDropDownBoxTitle={""}
        displayExpr={"displayAlias"}
        valueExpr={"statusId"}
        visible={
          props.currentBulkUpdateConfigurationName ===
            BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
          props.currentBulkUpdateFieldName?.toLowerCase() ===
            externalAuditCaseFieldNames.CASE_STATUS.toLowerCase()
        }
        onValueChanged={commonValueChangeHandler}
        id={""}
        value={props.currentBulkUpdateFieldValue}
        mdaeDataUpdaterConfig={[
          {
            actionType: GET_STATUS_LOOKUP_LIST,
            reducerName: "caseDataReducer",
            isAsyncComplete: true,
            widgetOptionBindings: {
              dataSource: undefined,
            },
          },
        ]}
      ></MdaeSelectBox>

      <MdaeSelectBox
        mdaeDropDownBoxTitle={""}
        displayExpr={"eaOutcomeName"}
        valueExpr={"eaOutcomeId"}
        visible={
          props.currentBulkUpdateConfigurationName ===
            BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
          props.currentBulkUpdateFieldName?.toLowerCase() ===
            externalAuditCaseFieldNames.ROUND_OUTCOME.toLowerCase()
        }
        onValueChanged={commonValueChangeHandler}
        id={""}
        value={props.currentBulkUpdateFieldValue}
        mdaeDataUpdaterConfig={[
          {
            actionType: GET_OUTCOMES_LIST,
            reducerName: "outcomesReducer",
            isAsyncComplete: true,
            widgetOptionBindings: {
              dataSource: "caseRoundOutcomeList",
            },
          },
        ]}
      ></MdaeSelectBox>
      <MdaeSelectBox
        mdaeDropDownBoxTitle={""}
        displayExpr={"denialReasonName"}
        valueExpr={"code"}
        visible={
          props.currentBulkUpdateConfigurationName ===
            BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
          props.currentBulkUpdateFieldName?.toLowerCase() ===
            externalAuditCaseFieldNames.DENIAL_REASON.toLowerCase()
        }
        onValueChanged={commonValueChangeHandler}
        id={""}
        value={props.currentBulkUpdateFieldValue}
        dataSource={denialReasonData}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.denialReasonCode",
            },
          },
        ]}
      ></MdaeSelectBox>

      <MdaeSelectBox
        mdaeDropDownBoxTitle={""}
        displayExpr={"eaOutcomeName"}
        valueExpr={"eaOutcomeId"}
        visible={
          props.currentBulkUpdateConfigurationName ===
            BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
          props.currentBulkUpdateFieldName?.toLowerCase() ===
            externalAuditCaseFieldNames.CASE_FINAL_OUTCOME.toLowerCase()
        }
        onValueChanged={commonValueChangeHandler}
        id={""}
        value={props.currentBulkUpdateFieldValue}
        mdaeDataUpdaterConfig={[
          {
            actionType: GET_OUTCOMES_LIST,
            reducerName: "outcomesReducer",
            isAsyncComplete: true,
            widgetOptionBindings: {
              dataSource: "caseFinalOutcomeList",
            },
          },
        ]}
      ></MdaeSelectBox>
      {props.currentBulkUpdateConfigurationName ===
        BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
        props.currentBulkUpdateFieldName?.toLowerCase() ===
          externalAuditCaseFieldNames.REFUND_SUBMMITED_DATE.toLowerCase() && (
          <MdaeDateBox
            mdaeDateBoxTitle=""
            type="date"
            onValueChanged={commonValueChangeHandler}
            value={props.currentBulkUpdateFieldValue}
            id={""}
          ></MdaeDateBox>
        )}

      {props.currentBulkUpdateConfigurationName ===
        BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
        props.currentBulkUpdateFieldName?.toLowerCase() ===
          externalAuditCaseFieldNames.REFUND_COMPLETED_DATE.toLowerCase() && (
          <MdaeDateBox
            mdaeDateBoxTitle=""
            type="date"
            onValueChanged={commonValueChangeHandler}
            value={props.currentBulkUpdateFieldValue}
            id={""}
          ></MdaeDateBox>
        )}

      {props.currentBulkUpdateConfigurationName ===
        BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
        props.currentBulkUpdateFieldName?.toLowerCase() ===
          externalAuditCaseFieldNames.CASE_ROUND_DETERMINATION_DATE.toLowerCase() && (
          <MdaeDateBox
            mdaeDateBoxTitle=""
            type="date"
            onValueChanged={commonValueChangeHandler}
            value={props.currentBulkUpdateFieldValue}
            id={""}
          ></MdaeDateBox>
        )}

      {props.currentBulkUpdateConfigurationName ===
        BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
        props.currentBulkUpdateFieldName?.toLowerCase() ===
          externalAuditCaseFieldNames.CASE_ROUND_SUBMISSION_DATE.toLowerCase() && (
          <MdaeDateBox
            mdaeDateBoxTitle=""
            type="date"
            onValueChanged={commonValueChangeHandler}
            value={props.currentBulkUpdateFieldValue}
            id={""}
          ></MdaeDateBox>
        )}

      {props.currentBulkUpdateConfigurationName ===
        BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
        props.currentBulkUpdateFieldName?.toLowerCase() ===
          externalAuditCaseFieldNames.ADVANCE_TO_NEXT_ROUND.toLowerCase() && (
          <MdaeSelectBox
            id={""}
            mdaeDropDownBoxTitle={""}
            onInitialized={() => {
              dispatch({
                type: UPDATE_BULK_UPDATE_ROW,
                data: {
                  sequenceNumber: props.currentSequenceNumber,
                  fieldValue: "Yes",
                },
              });
            }}
            visible={false}
          ></MdaeSelectBox>
        )}

      {props.currentBulkUpdateConfigurationName ===
        BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
        props.currentBulkUpdateFieldName?.toLowerCase() ===
          externalAuditCaseFieldNames.MANUAL_REFUND_REQUIRED.toLowerCase() && (
          <MdaeSelectBox
            id={""}
            mdaeDropDownBoxTitle={""}
            onValueChanged={commonValueChangeHandler}
            value={props.currentBulkUpdateFieldValue}
            dataSource={["Yes", "No"]}
          ></MdaeSelectBox>
        )}
        <MdaeSelectBox
        mdaeDropDownBoxTitle={""}
        displayExpr={"name"}
        valueExpr={"value"}
        visible={
          props.currentBulkUpdateConfigurationName ===
            BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
          props.currentBulkUpdateFieldName?.toLowerCase() ===
            externalAuditCaseFieldNames.TARGET_RATIONALE.toLowerCase()
        }
        onValueChanged={commonValueChangeHandler}
        id={""}
        value={props.currentBulkUpdateFieldValue}
        dataSource={TargetRationaleList}
      ></MdaeSelectBox> 
      <MdaeSelectBox
        mdaeDropDownBoxTitle={""}
        displayExpr={"fullName"}
        valueExpr={"auditUserId"}
        visible={
          props.currentBulkUpdateConfigurationName ===
            BULK_UPDATE_CONFIG_NAMES.EXTERNAL_AUDIT_CASE &&
          props.currentBulkUpdateFieldName?.toLowerCase() ===
            externalAuditCaseFieldNames.CASE_PROCESS_MANAGER.toLowerCase()
        }
        onValueChanged={commonValueChangeHandler}
        id={""}
        value={props.currentBulkUpdateFieldValue}
        dataSource={processManagers}
        mdaeDataUpdaterConfig={[
          {
            actionType: SET_CASE_FORM_DATA,
            reducerName: "caseDataReducer",
            widgetOptionBindings: {
              value: "caseData.caseProcessManagerId",
            },
          },
        ]}
      ></MdaeSelectBox>     
    </>
  );
};
